import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/Http';
import { AuthService } from '../../_services/auth.service';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;

  constructor(private http: HttpClient, private authService: AuthService, private router: Router) { }

  ngOnInit() {
  }
  

  login() {
    console.log(this.username);
    var params = {
      "Username": this.username,
      "Password": this.password
    }
    this.http.post<any>('https://api.miljoavgift.plantevernmidler.mattilsynet.io/api/users/authenticate', params)
    //this.http.post<any>('http://tolkapi.lds.no/api/users/authenticate', params)
    .subscribe(
      res => {
        //localStorage["avdelingId"] = res.id;
        localStorage["slt_id"] = res.id;
        var id_navn = res.id + "-" + res.firmanavn;
        localStorage["id_navn"] = id_navn;
        localStorage["innrappdato"] = res.innrappdato;
        
        this.authService.login(res.token);
        this.router.navigate(['/']);
        console.log('123');
        console.log(res);
      },
      err => {
        console.log(err);
        notify('Feil brukernavn/passord')
        //this.nybestilling={};
      }
    )
  }
}



// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/app/login/login.component.ts